// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cZKTr","colBig":"styles_colBig__1Rn2u","colSmall":"styles_colSmall__1TrCK"};